import Carousel from '@mozaic-ds/freemarker/js/modules/_carousel.js';
lm.DOMReady(() => {
  const myCarouselElements = document.querySelectorAll('.arm-products-sponsored-carousel .mc-carousel');
  new Carousel(myCarouselElements[0], {
    centerWhenNoButtons: true
  });
});